import {
  Button,
  GroupTextField,
  GroupTextFieldRow,
  Heading,
} from "@elaniintc/goes-design-system";
import { useDocumentGeneratorNode } from "../hooks";
import { useGetVariables } from "@/workflow_api/hooks/variables/useGetVariables";
import { DocumentFieldValueInput } from "../components/DocumentFieldValueInput";
import type { Variable } from "../types";

export const DocGeneratorCreateForm = () => {
  const { fields, setFields } = useDocumentGeneratorNode();
  const { variables } = useGetVariables();

  console.log(fields);

  const updateFieldInputType = (
    name: string,
    inputType: "input" | "variable",
  ) => {
    setFields(
      fields.map((field) =>
        field.name === name ? { ...field, inputType, value: "" } : field,
      ),
    );
  };

  const updateFieldValue = (name: string, value: string | Variable) => {
    setFields(
      fields.map((field) =>
        field.name === name ? { ...field, value } : field,
      ),
    );
  };

  return (
    <div className="w-full pt-3 pb-6 px-4 border-b-1 border-neutral-quiet flex flex-col gap-2">
      <Heading variant="h6">Datos Esperados</Heading>
      {fields.map((field) => (
        <GroupTextField
          key={field.name}
          label={field.label}
          // required={field.required}
          // labelHelperText={field.required ? "" : "Opcional"}
          required
          className="w-full flex-auto"
        >
          <GroupTextFieldRow>
            <Button
              variant="quiet"
              type="button"
              className="font-mono"
              onClick={() =>
                updateFieldInputType(
                  field.name,
                  field.inputType === "input" ? "variable" : "input",
                )
              }
            >
              {field.inputType === "input" ? "inp" : "var"}
            </Button>
            <DocumentFieldValueInput
              field={field}
              value={field.value}
              onValueChange={(value) => updateFieldValue(field.name, value)}
              inputVariables={variables}
              group="right"
              placeholder={field.placeholder}
            />
          </GroupTextFieldRow>
        </GroupTextField>
      ))}
    </div>
  );
};
